import React from "react";
import {SupplyDTO} from "../../../../models/SupplyDTO";
import {OzonFilterToggle} from "../ui/OzonFilterToggle";
import {formatWarehouses} from "../utils/format";

export function TypesSection({
                                 typesToShow,
                                 isLoading,
                                 ozonFilter,
                                 setOzonFilter,
                                 onDeleteType,
                                 innerRef,
                             }: {
    typesToShow: any[]; // можно сделать SupplyDTO & {isOzon?:boolean} если хочешь
    isLoading: boolean;
    ozonFilter: boolean;
    setOzonFilter: (v: boolean) => void;
    onDeleteType: (t: SupplyDTO) => void;
    innerRef: React.RefObject<HTMLDivElement | null>;
}) {
    return (
        <>
            <div ref={innerRef} style={{marginTop: 18}}>
                <h2 className="supplies-section-title">Типы поставок (структура)</h2>
                <p className="supplies-section-note">
                    Здесь удаляется <b>структура</b> типа поставки. Его можно удалить только если нет связанных текущих
                    или планируемых поставок или шаблонов.
                </p>
            </div>

            <OzonFilterToggle name="typesFilter" value={ozonFilter} onChange={setOzonFilter}/>

            <div className="admin-table-wrapper">
                <table className="admin_table supplies-table">
                    <thead>
                    <tr>
                        <th>Название</th>
                        <th>Склады</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {isLoading && (
                        <tr>
                            <td colSpan={4} className="admin-table-loading">
                                <span className="admin-spinner"/> Загрузка...
                            </td>
                        </tr>
                    )}

                    {!isLoading &&
                        typesToShow.map((t: any) => (
                            <tr key={t.id}>
                                <td>{t.title}</td>
                                <td>{formatWarehouses(t.warehouses)}</td>
                                <td>
                                    <div className="supplies-actions">
                                        <button
                                            className="admin-button-secondary admin-button-secondary--danger"
                                            onClick={() => onDeleteType(t)}
                                        >
                                            Удалить
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}

                    {!isLoading && typesToShow.length === 0 && (
                        <tr>
                            <td colSpan={4} className="admin-table-empty">Нет типов для выбранного фильтра.</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </>
    );
}
